

function checkCategory(date) {
  if (date >= 1 && date <= 14) {
    return "first_quarter"
  }
  else {
    return "second_quarter"
  }
}



export function checkValidObject(object:any){
  let objKeys = Object.keys(object);
  if(objKeys.length > 0){
    return true
  }else{
    return false
  }
}





//   // console.log(unique)



export function invoiceFilter(customerInvoices, customerNewInvoices) {
  let filteredInvoices: any = [];

  // Avoid repeating date parsing by storing Date objects.
  customerInvoices.forEach((invoice: any) => {
    let inv: any = null;  // Set to null initially to check if we find a match

    // Parse the invoice dueDate only once for efficiency.
    const invoiceDueDate = new Date(invoice.dueDate);
    const invoiceMonth = invoiceDueDate.getMonth();
    const invoiceYear = invoiceDueDate.getFullYear();
    const invoiceDayCategory = checkCategory(invoiceDueDate.getDate());

    for (let i of customerNewInvoices) {
      // Parse the new invoice date once.
      const newInvoiceDueDate = new Date(i.dueDate);
      const newInvoiceMonth = newInvoiceDueDate.getMonth();
      const newInvoiceYear = newInvoiceDueDate.getFullYear();
      const newInvoiceDayCategory = checkCategory(newInvoiceDueDate.getDate());

      const sameSet = invoiceDayCategory === newInvoiceDayCategory;

      console.log(
        new Date(invoice.dueDate),
        newInvoiceMonth,
        invoiceMonth,
        sameSet,
        invoiceYear === newInvoiceYear
      );

      // Match condition for both month, year, and category
      if (invoiceMonth === newInvoiceMonth && invoiceYear === newInvoiceYear && sameSet) {
        inv = i;
        break; // If we found a match, exit the loop
      }
    }

    // Add the matched or original invoice to the result array
    if (inv !== null) {
      filteredInvoices.push(inv);
    } else {
      filteredInvoices.push(invoice);
    }
  });

  // Merge the new invoices and customerInvoices, ensuring uniqueness by dueDate.
  filteredInvoices = [...filteredInvoices, ...customerNewInvoices];

  // Ensure uniqueness using dueDate as the unique key for filtering
  const unique = filteredInvoices.filter((obj, index) => {
    return index === filteredInvoices.findIndex(o => new Date(obj.dueDate).getTime() === new Date(o.dueDate).getTime());
  });

  return unique;
}
export const sumBy = (items: Array<any>, prop: string) =>
  items.reduce((a, b) => +a + +parseFloat(b[prop]), 0);
export const adjustWith2DecimalsForUI = (amount: any) =>
  +parseFloat(amount.toString()).toFixed(2);

export const BackdatedReasons = {
  "spouse": {
    "ADD_SPOUSE_EFFECTIVE_BACKDATED": "Plan need to be effective retroactively.",
    "REMOVE_SPOUSE_EFFECTIVE_BACKDATED": "Plan need to be effective retroactively.",
    "MARRIED_30_BEFORE_NOT_COVERED": "Marriage occurred over 30 days ago, and the spouse is not covered.",
    "MARRIED_30_BEFORE_COVERED": "Marriage occurred over 30 days ago, and the spouse is covered but requested for plan change.",
    "COMMONLAW_365_BEFORE_NOT_COVERED": "Living together for more than a year, but the spouse is not covered.",
    "COMMONLAW_365_BEFORE_COVERED": "Living together for more than a year and the spouse is covered but requested for plan change."
  },
  "children": {
    "ADD_CHILDREN_EFFECTIVE_BACKDATED": "Plan need to be effective retroactively.",
    "REMOVE_CHILDREN_EFFECTIVE_BACKDATED": "Plan need to be effective retroactively.",
    "CHILDREN_WITH_DISABLITY": "The child has a disability.",
    "CHILDREN_ABOVE_18_NO_STUDENT_NOT_COVERED": "The child is over 18, not a student, and not covered.",
    "CHILDREN_ABOVE_18_STUDENT_NOT_COVERED": "The child is over 18, a student, but not covered."
  } 
}
